<template>
  <div :class="cn('flex flex-col rounded-t-xl', props.class)">
    <div
      class="flex items-center justify-between py-1.5 px-2 text-primary text-style-lg font-semibold text-center"
    >
      <div class="w-20 flex items-center">
        <slot name="leading">
          <Button
            v-if="leadingAction"
            :as="leadingAction.as"
            :label="leadingAction.iconOnly ? undefined : leadingAction.label"
            :variant="variant"
            :type="type"
            :size="size"
            :aria-label="leadingAction.label"
            class="whitespace-nowrap"
            @click="$emit(leadingAction.event)"
          >
            <template v-if="leadingAction.icon" #start>
              <Icon :name="leadingAction.icon" size="xl" aria-hidden />
            </template>
          </Button>
        </slot>
      </div>
      <DrawerTitle class="grow pointer-events-none">
        {{ title }}
      </DrawerTitle>
      <div class="w-20 flex items-center justify-end">
        <slot name="trailing">
          <Primitive asChild>
            <slot name="close">
              <DrawerClose
                ref="close"
                :as="CloseButton"
                size="lg"
                :aria-label="$t('components.buttons.close')"
              />
            </slot>
          </Primitive>
        </slot>
      </div>
    </div>
    <slot name="tabs">
      <div v-if="withSearch" class="px-3 pb-3">
        <slot name="search" :query="query.trim().toLowerCase()">
          <DrawerSearch v-model="query" />
        </slot>
      </div>
    </slot>
  </div>
</template>

<script setup>
import { computed, ref } from "vue";
import { Primitive } from "radix-vue";
import { Icon } from "@/SharedComponents/Icon";
import { Button, CloseButton } from "@/SharedComponents/Buttons";
import {
  DrawerClose,
  DrawerTitle,
  DrawerSearch,
} from "@/SharedComponents/Drawer";
import { cn } from "@/Utils/cn";

const close = ref(null);

const props = defineProps({
  title: { type: String, required: true },
  leadingAction: { type: Object, required: false },
  variant: { type: String, default: "tertiary" },
  type: { type: String, default: "gray" },
  size: { type: String, default: "xl" },
  withSearch: { type: Boolean, default: false },
  class: { type: null, required: false },
});

const query = ref("");

defineExpose({
  query: computed(() => query.value.trim().toLowerCase()),
  clearQuery: () => (query.value = ""),
  close: () => close.value?.$el.click(),
});
</script>
